<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ titleFn }}</span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="pr-5" large v-on="on"  @click="toPrint()">local_printshop</v-icon>
          </template>
          <span>Imprimir</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text v-if="deuda">
        <v-flex xs12 sm6 md6>
          <v-text-field
            type="text"
            v-model="object.nombre"
            label="Nombre"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field
            type="text"
            v-model="object.deuda"
            label="Deuda"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field
            type="text"
            v-model="object.pagado"
            label="Pagado"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field
            type="text"
            v-model="object.descripcion"
            label="Descripción"
          ></v-text-field>
        </v-flex>
      </v-card-text>
      <v-card-text v-if="transaccion">
        <div id="transaccion" style="page-break-before: always;">
          <header style="display: flex">
            <div id="fact" style="flex-grow: 2">
              <p>
                Cliente: {{ clientesAutocomplete(object.persona) }}
                <br />
                Fecha: {{ object.fecha }}
              </p>
            </div>
          </header>
          <br />
          <section>
            <div>
              <span>Detalle transacción</span>
              <table id="facarticulo" style="width: 100%;">
                <thead
                  style="background: #2183e3 !important; color:white; padding-top: 5px !important; padding-bottom:5px !important"
                >
                  <tr id="fa" style="background: #2183e3 !important;">
                    <th>TOTAL</th>
                    <th>PAGADO</th>
                    <th>DIFERENCIA</th>
                    <th>DESCRIPCION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="text-align:center !important;">
                      $ {{ object.total }}
                    </td>
                    <td style="text-align:center !important;">
                      $ {{ object.pagado }}
                    </td>
                    <td style="text-align:right; padding-top10px !important">
                      $ {{ object.monto }}
                    </td>
                    <td style="text-align:right; padding-top10px !important">
                       {{ object.descripcion }}
                    </td>
                  </tr>
                </tbody>
                <tfoot style="padding-top: 15px;">
                    <tr>
                      <th></th>
                      <th></th>
                      <th style="text-align:right;">DEUDA</th>
                      <th style="text-align:right;">$ {{ object.deuda }}</th>
                    </tr>
                  </tfoot>
              </table>
            </div>
          </section>
          <section v-if="object.venta">
            <div>
              <span>Detalle venta</span>
              <table id="facarticulo" style="width: 100%;">
                  <thead style="background: #2183e3 !important; color:white; padding-top: 5px !important; padding-bottom:5px !important">
                    <tr id="fa" style="background: #2183e3 !important;">
                      <th>CANT</th>
                      <th>UNIDAD</th>
                      <th>ARTICULO</th>
                      <th>PRECIO</th>
                      <th>TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="det in venta.detalles" :key="det._id">
                      <td style="text-align:center !important;">{{ det.cantidad }}</td>
                      <td style="text-align:center !important;">{{ det.unidad }}</td>
                      <td style="text-align:center !important;">{{ det.articulo }}</td>
                      <td style="text-align:center !important;">$ {{ det.precio }}</td>
                      <td style="text-align:right; padding-top10px !important">
                        $ {{ det.cantidad * det.precio }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot style="padding-top: 15px;">
                    <tr>
                      <th></th>
                      <th style="text-align:right;">TOTAL</th>
                      <th style="text-align:right;">$ {{ venta.total }}</th>
                      <th style="text-align:right;">PAGADO</th>
                      <th style="text-align:right;">$ {{ venta.pagado }}</th>
                    </tr>
                  </tfoot>
                </table>
            </div>
          </section>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
          {{ deuda ? "Cancelar" : "Volver" }}
        </v-btn>
        <v-btn v-if="!transaccion" color="blue darken-1" text @click="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      title: ""
    };
  },
  props: {
    object: Object,
    venta: Object,
    show: Boolean,
    transaccion: Boolean,
    deuda: Boolean,
  },
  computed: {
    ...mapState("clienteNamespace", ["clientes"]),
    titleFn() {
      return this.deuda
        ? (this.title = "Edición deuda")
        : (this.title = "Detalle transacción");
    }
  },
  methods: {
    clientesAutocomplete(id) {
      let clientes = this.clientes;
      let nombre = '';
      clientes.forEach(element => {
        if(element._id == id) {
          nombre = element.nombre
        }
      });
      return nombre;
    },
    toPrint(){
      this.$htmlToPaper('transaccion')
    },
    guardar() {
      this.$emit("save", this.object);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
